import clsx from "clsx"
import PropTypes from "prop-types"
import { useHistory } from "react-router"

const NewTabs = ({ doc, tabs }) => {
  const history = useHistory()

  return (
    <div
      className="h-[50px] flex gap-4"
      style={{ boxShadow: "rgba(0, 0, 0, 0.082) 0px 3px 6px" }}
    >
      {tabs.map((tab) => {
        const selected = history.location.pathname.includes(tab.id)
        return (
          <button
            key={tab.id}
            onClick={() => history.push(`/documents/${doc.id}/${tab.id}`)}
            className={clsx(
              "p-4 text-[12px] flex gap-1 cursor-pointer",
              selected && "bg-[#C8E5E7] text-[#17A5B1]",
            )}
          >
            <img src={selected ? tab.activeIcon : tab.icon} />
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}

NewTabs.propTypes = {
  doc: PropTypes.object,
  tabs: PropTypes.array,
}

export default NewTabs
